import React from "react";

import {
    Box,
    Typography
} from "@mui/material";

import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export default function EmptyState() {

    return (

        <Box
            sx={{
                py: 10,
                textAlign: "center"
            }}
        >

            <FolderOpenIcon
                sx={{
                    fontSize: 70,
                    color: "text.secondary"
                }}
            />

            <Typography
                variant="h6"
                sx={{ mt: 2 }}
            >

                No documents found

            </Typography>

            <Typography
                color="text.secondary"
            >

                Synchronize Google Drive to import knowledge.

            </Typography>

        </Box>

    );

}